export default class CreateSeguimientoResultadoC3 {
  #repository

  constructor(repository) {
    this.#repository = repository
  }

  async execute(idPersonal, idResultado, seguimiento) {
    return await this.#repository.create(idPersonal, idResultado, seguimiento)
  }
}
